import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SEOHead from "@/components/feature/SEOHead";
import SchemaOrg from "@/components/feature/SchemaOrg";

export default function About() {
  const faqs = [
    {
      q: "虚空韩漫网有哪些类型的漫画？",
      a: "虚空韩漫网作为专业的韩漫画免费网站，提供漫画大全服务，涵盖恋爱、奇幻、动作、悬疑、剧情、BL、GL、搞笑、恐怖等多种类型的韩漫完整在线观看。无论您喜欢什么风格，都能在这里找到心仪的作品。",
    },
    {
      q: "网站更新频率如何？",
      a: "我们致力于与韩国原版保持同步更新，每日都有新话数上线。热门连载漫画通常每周更新1-2话，确保读者能第一时间看到最新内容。作为稳定的韩漫平台，我们始终把更新速度放在首位。",
    },
    {
      q: "是否需要注册才能阅读？",
      a: "不需要！虚空韩漫网所有漫画均可免费在线阅读，无需注册或登录账号。我们相信优质的韩漫内容应当对所有人开放，平台稳定、访问便捷，让阅读变得简单纯粹。",
    },
    {
      q: "支持哪些设备阅读？",
      a: "我们的网站采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您用台式机、笔记本还是手机浏览器，都能获得流畅舒适的韩漫阅读体验。",
    },
    {
      q: "如何联系网站管理员？",
      a: "您可以通过页面底部的联系方式或关于我们页面的联系表单与我们取得联系。我们重视每一位读者的反馈，会尽快回复您的咨询和建议。",
    },
  ];

  return (
    <>
      <SEOHead
        title="关于我们 - 虚空韩漫网 | 品牌介绍_口碑_联系方式"
        description="虚空韩漫网作为韩漫画免费网站，致力于提供漫画大全和韩漫完整在线观看服务。了解我们的品牌故事、用户口碑与联系方式，平台稳定是您可靠的长久阅读伙伴。"
        keywords="虚空韩漫网,关于我们,韩漫画免费网站,品牌介绍,联系方式,韩漫平台口碑"
        canonicalUrl="https://www.xukonghanman.com/about"
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "虚空韩漫网",
          url: "https://www.xukonghanman.com/",
          description: "虚空韩漫网作为韩漫画免费网站，提供漫画大全和韩漫完整在线观看服务",
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
            email: "contact@xukonghanman.com",
            availableLanguage: ["Chinese"],
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "关于我们 - 虚空韩漫网",
          url: "https://www.xukonghanman.com/about",
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "首页",
              item: "https://www.xukonghanman.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "关于我们",
            },
          ],
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqs.map((faq) => ({
            "@type": "Question",
            name: faq.q,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.a,
            },
          })),
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <Breadcrumb />

        <section className="max-w-5xl mx-auto px-4 md:px-6 py-12" aria-label="品牌介绍">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            关于虚空韩漫网
          </h1>
          <p className="text-sm text-foreground-500 text-center mb-12 max-w-2xl mx-auto">
            韩漫画免费网站，提供漫画大全和韩漫完整在线观看服务
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
            <div className="relative overflow-hidden rounded-2xl aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20cozy%20reading%20room%20with%20bookshelves%20and%20warm%20lighting%2C%20soft%20watercolor%20manga%20style%2C%20peaceful%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=about-brand-01&orientation=landscape"
                alt="虚空韩漫网品牌形象"
                className="w-full h-full object-cover object-top"
                title="虚空韩漫网 - 品牌形象"
              />
            </div>
            <div className="flex flex-col justify-center">
              <h2 className="text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                品牌故事
              </h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                虚空韩漫网成立于2023年，由一群热爱韩漫的资深读者共同创建。我们深知韩漫爱好者对于高质量阅读体验的追求，因此倾力打造了这个集漫画大全与韩漫完整在线观看于一体的综合平台。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                作为专业的韩漫画免费网站，我们始终坚持内容为王，与多家韩国漫画平台保持密切合作，第一时间为读者带来最热门、最优质的韩漫资源。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                平台稳定是我们的核心竞争力。我们投入大量资源优化服务器架构，确保7x24小时不间断服务，让每一位读者都能享受流畅的韩漫阅读体验。虚空韩漫网，做您可靠的长久阅读伙伴。
              </p>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16" aria-label="用户口碑">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: "小樱",
                  comment:
                    "虚空韩漫网真的是我见过最稳的韩漫平台！更新速度快，画质清晰，收藏的漫画从来没有加载不出来的情况。作为韩漫画免费网站，体验真的太棒了！",
                  rating: 5,
                },
                {
                  name: "漫画迷阿杰",
                  comment:
                    "找了好久终于找到一个靠谱的韩漫完整在线观看的网站。漫画大全分类很细，想看的类型都能找到。已经推荐给身边所有喜欢韩漫的朋友了！",
                  rating: 5,
                },
                {
                  name: "月亮不睡我不睡",
                  comment:
                    "每天晚上刷韩漫已经成了习惯，虚空韩漫网的界面简洁大方，手机端阅读体验也很好。最重要的是免费！真的良心平台，会一直支持的。",
                  rating: 5,
                },
              ].map((review, i) => (
                <div
                  key={i}
                  className="p-6 rounded-xl bg-background-50 border border-background-200"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, j) => (
                      <span key={j} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{review.comment}"
                  </p>
                  <p className="text-xs font-semibold text-foreground-900">
                    — {review.name}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
              {[
                { num: "50万+", label: "活跃用户" },
                { num: "99.9%", label: "服务可用率" },
                { num: "4.9", label: "用户评分" },
                { num: "100+", label: "每日更新" },
              ].map((stat) => (
                <div key={stat.label} className="p-4 rounded-xl bg-background-50 border border-background-200">
                  <p className="text-xl md:text-2xl font-bold text-primary-500" style={{ fontFamily: "var(--font-heading)" }}>
                    {stat.num}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16" aria-label="联系方式">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-10">
              如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-5">
                {[
                  {
                    icon: "ri-mail-line",
                    title: "电子邮箱",
                    content: "contact@xukonghanman.com",
                  },
                  {
                    icon: "ri-wechat-line",
                    title: "微信公众号",
                    content: "虚空韩漫网",
                  },
                  {
                    icon: "ri-weibo-line",
                    title: "官方微博",
                    content: "@虚空韩漫网",
                  },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200">
                    <div className="w-10 h-10 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                        <i className={item.icon}></i>
                      </span>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600">{item.content}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-background-100 border border-background-200 rounded-xl p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  发送消息
                </h3>
                <form
                  className="space-y-4"
                  onSubmit={(e) => {
                    e.preventDefault();
                    alert("消息已发送！我们会尽快回复您。");
                    (e.target as HTMLFormElement).reset();
                  }}
                  data-readdy-form
                >
                  <div>
                    <label htmlFor="about-name" className="block text-xs font-medium text-foreground-700 mb-1">
                      姓名
                    </label>
                    <input
                      type="text"
                      id="about-name"
                      name="name"
                      required
                      className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-xs font-medium text-foreground-700 mb-1">
                      邮箱
                    </label>
                    <input
                      type="email"
                      id="about-email"
                      name="email"
                      required
                      className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-xs font-medium text-foreground-700 mb-1">
                      消息
                    </label>
                    <textarea
                      id="about-message"
                      name="message"
                      required
                      rows={4}
                      maxLength={500}
                      className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                      placeholder="请输入您想说的话（最多500字）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="opacity-0 absolute top-0 left-0 h-0 w-0 -z-10 pointer-events-none"
                  />
                  <button
                    type="submit"
                    className="w-full py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-300 whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16" aria-label="常见问题">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 text-center mb-10" style={{ fontFamily: "var(--font-heading)" }}>
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, i) => (
                <details
                  key={i}
                  className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                    <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</h3>
                    <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform duration-300">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}